// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

//Components
import { DescriptionContent } from './PlaceDescription';

// Actions
import { toggleFeatureDescription } from '../actions';

// Shapes & Types
import { layerShape, featureShape } from '../propTypesShapes';
import { profileShape } from '../../authentication/propTypesShapes';

// Assets
import './LayerHeading.css';

// Utils
import { isFirstRender } from '../../shared/utils/data';


class LayerHeading extends React.PureComponent {
  static propTypes = {
    currentLayer: layerShape,
    currentFeature: featureShape,
    showCurrentFeatureInfo: PropTypes.bool,
    isFetchingDataLayer: PropTypes.bool,
    hideResultsInfo: PropTypes.bool,
    isFeatureDescriptionShown: PropTypes.bool,
    profile: profileShape
  };

  constructor(props) {
    super(props);

    this.state = {
      currentFeatureStatus: {
        hasDetails: true,
        selected: true
      }
    };

    this.handleCurrentFeatureOnClick = this.handleCurrentFeatureOnClick.bind(this);
  }

  handleCurrentFeatureOnClick(featureId) {
    const { currentFeature, dispatch } = this.props;

    if (currentFeature && featureId === currentFeature.id) {
      dispatch(toggleFeatureDescription());
    }
  }

  renderFeature(feature) {
    const { id, properties } = feature;
    const { currentFeatureStatus } = this.state;
    const { isFeatureDescriptionShown, profile } = this.props;

    if (isFirstRender(currentFeatureStatus)) {
      return null;
    }

    return (
      <li className="MenuNavOption" key={id}>
        <div
          className={`MenuOptionLink d-flex justify-content-between align-items-center ${
            currentFeatureStatus.hasDetails ? 'icon-arrow': ''}`}
          name={`option${id}`}
          data-toggle="collapse"
          aria-expanded={isFeatureDescriptionShown}
          aria-selected={currentFeatureStatus.selected}
          onClick={() => this.handleCurrentFeatureOnClick(id)}
        >
          {properties.name}
        </div>

        {currentFeatureStatus.hasDetails &&
          <ul className={`MenuTierContainer collapse list-unstyled ${
            isFeatureDescriptionShown ? 'show' :''}`}
          >
            <li className="MenuNavOption">
              <div className="MenuOptionContent">
                <DescriptionContent
                  profile={profile}
                  featureProperties={properties}
                />
              </div>
            </li>
          </ul>
        }
      </li>
    );
  }

  render() {
    const {
      showCurrentFeatureInfo, isFetchingDataLayer, hideResultsInfo,
      currentLayer, currentFeature, isFeatureDescriptionShown
    } = this.props;
    const enabledFeatureSupport = showCurrentFeatureInfo && currentFeature;
    let layerName = '';
    let resultsCount = 0;

    if (currentLayer) {
      layerName = currentLayer.mapLayer.name || '';
      resultsCount = currentLayer.dataLayer.features.length;
    }

    return (
      <div className={`LayerHeading ${isFeatureDescriptionShown ?'Scrollable' :''}`}>
        {isFetchingDataLayer ? (
          <span className="LayerHeadingContent d-flex align-items-center">
            Loading...
          </span>
        ) : enabledFeatureSupport ? (
          <ul className="MenuNavBar list-unstyled">
            {this.renderFeature(currentFeature)}
          </ul>
        ) : (
          <div className="LayerHeadingContent d-flex justify-content-between align-items-center">
            <span className="">
              {layerName.toUpperCase()}
            </span>
            {!hideResultsInfo &&
              <React.Fragment>
                <span className="LayerHeadingDivider" />
                <span className="LayerHeadingResults text-nowrap">
                  {resultsCount} RESULTS
                </span>
              </React.Fragment>
            }
          </div>
        )}
      </div>
    );
  }
}

LayerHeading.defaultProps = {
  showCurrentFeatureInfo: false,
  hideResultsInfo: false
};

export default connect(({ authentication,home }) => ({
  isFetchingDataLayer: home.isFetchingDataLayer,
  currentLayer: home.currentLayer,
  currentFeature: home.currentFeature,
  isFeatureDescriptionShown: home.isFeatureDescriptionShown,
  profile: authentication.profile
}), null)(LayerHeading);
